import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

interface GroupsActions {
  onEdit: () => void;
}

export function GroupActions({ onEdit }: GroupsActions) {
  return (
    <Button
      variant="contained"
      startIcon={<EditIcon />}
      onClick={onEdit}
      fullWidth
      data-testid="edit-group-button"
    >
      Edit Group
    </Button>
  );
}
